import Utilities from '..';

export function JSONBeautify(jsonString: string): string | undefined {
  try {
    let value = jsonString;
    const data = Utilities.checkAndReturnValidJsonWithVariables(value);
    if (data.is_valid && data.value) {
      value = JSON.stringify(data.value);
    } else {
      console.error('Invalid JSON format. Please check and try again.');
    }

    const parsed = JSON.parse(value);
    return JSON.stringify(parsed, null, 2);
  } catch (e: any) {
    console.error('Invalid JSON format:', e.message);
  }
}
